import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';

import CheckMarkGreenSVG from '../../../assets/check-mark-green.svg';
import VerificationEmailSVG from '../../../assets/verification-email.svg';
import { CreditCardApplicationContext } from '../../../CreditCardApplicationContext';
import Card, { ErrorCard, LoadingCard } from 'src/commons/components/Card';
import Heading from 'src/commons/components/Heading';
import {
  MOBILE_BREAKPOINT,
  CARD_BREAKPOINT,
  colors,
  PageNames,
} from 'src/commons/constants';

// Styles -----------------------------------------------------------------------------------------
const VerificationEmailIcon = styled(VerificationEmailSVG)`
  height: 6.9375rem;
  width: 6.9375rem;
  margin: 3.625rem 0 1.5rem;
`;
VerificationEmailIcon.displayName = 'VerificationEmailIcon';

const StyledHeading = styled(Heading)`
  max-width: 22rem;
  line-height: 2rem;
`;
StyledHeading.displayName = 'StyledHeading';

const StyledParagraph = styled.p`
  max-width: 22.5rem;
  margin: 1.0625rem 3.75rem 0;
  line-height: 1.375rem;
  font-size: 0.875rem;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    max-width: 16rem;
    margin: 1rem 0 0;
  }
`;
StyledParagraph.displayName = 'StyledParagraph';

const ConfirmTextContainer = styled.div`
  height: 3.5rem;
  margin: 2.75rem 0 0;
  border-radius: 2rem;
  padding: 0 1.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 1.75rem 0;
  }
`;
ConfirmTextContainer.displayName = 'ConfirmTextContainer';

const CheckMarkGreenIcon = styled(CheckMarkGreenSVG)`
  width: 0.9375rem;
  height: 0.9375rem;
  min-width: 0.9375rem;
  min-height: 0.9375rem;
`;
CheckMarkGreenIcon.displayName = 'CheckMarkGreenIcon';

const ConfirmText = styled.p`
  margin: 0 0.375rem 0 0.625rem;
  font-weight: 400;
  white-space: pre;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 0 0 0.625rem;
  }
`;
ConfirmText.displayName = 'ConfirmText';

export const VerificationEmail = () => {
  // Context --------------------------------------------------------------------------------------
  const {
    fetchAndResumeCreditCardApplication,
    fetchingApplication,
    showApplicationFetchError,
  } = useContext(CreditCardApplicationContext);

  // Hooks ----------------------------------------------------------------------------------------
  useEffect(() => {
    fetchAndResumeCreditCardApplication(PageNames.VERIFICATION_EMAIL);
  }, []);

  if (fetchingApplication) {
    return <LoadingCard />;
  }

  if (showApplicationFetchError) {
    return <ErrorCard />;
  }

  return (
    <Card id="verification-email-card">
      <VerificationEmailIcon id="verification-email-icon" />
      <StyledHeading id="verification-email-heading">
        The verification process is taking longer than usual
      </StyledHeading>
      <StyledParagraph id="verification-email-message">
        Processing may take up to 48 hours and we don’t want to waste your
        time—you’ll hear from us soon! You can close this window.
      </StyledParagraph>
      <ConfirmTextContainer id="confirm-text-container">
        <CheckMarkGreenIcon id="confirm-checkmark-icon" />
        <ConfirmText id="confirm-text">
          We’ll email you when complete
        </ConfirmText>
      </ConfirmTextContainer>
    </Card>
  );
};
